<script setup lang="ts">
import { computed } from 'vue'

import ExternalSidebarNavigation from '@/Components/ExternalSidebar/ExternalSidebarNavigation.vue'
import SidebarNavigation from '@/Components/Sidebar/SidebarNavigation.vue'
import { useUser } from '@/Composables'

import type { Navigation } from '@/Types'

defineProps<{
  navigation: Navigation[]
  navigationCustomerAccesses: App.Data.CustomerAccess.CustomerAccessData[]
}>()

const userRole = computed(() => useUser().value.role)
</script>

<template>
  <div class="flex h-full">
    <div v-if="userRole == 'extern'" class="flex-none">
      <ExternalSidebarNavigation
        :items="navigation"
        :navigation-customer-accesses="navigationCustomerAccesses"
      />
    </div>

    <div v-else class="flex-none">
      <SidebarNavigation :items="navigation" />
    </div>

    <div class="isolate min-w-0 grow overflow-y-auto">
      <slot />
    </div>
  </div>
</template>
